export default "__VITE_ASSET__BeQpJpE___"